import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import type { FC } from "react";
import { useEffect } from "react";

export const ReadOnlyPlugin: FC<{ readonly: boolean }> = ({ readonly }) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    editor.setEditable(!readonly);
  }, [readonly, editor]);

  return null;
};
